<div class="container h-100">
  <div class="h-100 row justify-content-center align-items-center">
    <div class="col-12 col-sm-8 col-md-12 col-lg-6 col-xl-5">
      <div class="d-flex flex-column align-items-center">
        <img src="/assets/icons/add_new_chat.svg" alt="add_new_chat" class="mb-6">
        <p class="fs-4 text-primblack mb-1 fw-bold">
          You haven’t any tasks yet
        </p>
        <p class="fs-5 mb-10 fw-bold">
          Tap the button below to create new task
        </p>
        <button
          type="button"
          class="btn app-btn-yellow btn-outline w-100"
          (click)="createNewTask()"
        >
          Create new task
        </button>
      </div>
    </div>
  </div>
</div>
